class SimpleStruct {
    public value: number;
    public label?: string;
    public additionalData?: string[];

    constructor() {
        this.value = -1;
    }

    static from(json: any) {
        return Object.assign(new SimpleStruct(), json);
    }
}

export default SimpleStruct;
